import { useRouter } from "@/app/components/lib/navigation/useRouter";
import useIsRtl from "@/hooks/useIsRtl";

const SVgAuthBack: React.FC<{ onClickBack?: () => void }> = ({
  onClickBack,
}) => {
  const router = useRouter();
  const isRtl = useIsRtl();
  return (
    <svg
      onClick={!!onClickBack ? onClickBack : () => router.replace("/")}
      style={{
        cursor: "pointer",
        ...(isRtl && {
          display: "block",
          transform: "scale(-1,1)",
        }),
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10447_66316)">
        <path
          d="M15.9844 3.19175C15.7765 3.19795 15.5793 3.28481 15.4344 3.43394L7.43437 11.4339C7.2844 11.584 7.20015 11.7874 7.20015 11.9996C7.20015 12.2117 7.2844 12.4152 7.43437 12.5652L15.4344 20.5652C15.5081 20.642 15.5964 20.7033 15.6941 20.7455C15.7918 20.7877 15.8969 20.81 16.0034 20.8111C16.1098 20.8122 16.2154 20.792 16.3139 20.7518C16.4125 20.7116 16.502 20.6521 16.5773 20.5768C16.6525 20.5016 16.712 20.412 16.7522 20.3135C16.7925 20.215 16.8126 20.1094 16.8116 20.0029C16.8105 19.8965 16.7882 19.7914 16.7459 19.6937C16.7037 19.596 16.6424 19.5077 16.5656 19.4339L9.13124 11.9996L16.5656 4.56519C16.6812 4.45282 16.7602 4.30815 16.7921 4.15013C16.8241 3.99212 16.8076 3.82813 16.7448 3.67966C16.6819 3.53119 16.5757 3.40517 16.44 3.31811C16.3043 3.23104 16.1455 3.187 15.9844 3.19175Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_10447_66316">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SVgAuthBack;
